<div class="row action-toolbar" style="margin-top: 20px">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
            <grid-export [grid]="mainGrid" [name]="'Estimate Vs Actual'"></grid-export>

            <div class="input-header-group">
                <span class="input-header">Close Month Start</span>
                <wj-input-date
                    [(ngModel)]="startDate"
                    class="header-input"
                    name="startDate"
                    (ngModelChange)="groupRows()"
                    [selectionMode]="'Month'"
                    [format]="'MMM yyyy'"
                    [min]="minDate"
                    [max]="maxDate"
                ></wj-input-date>
            </div>

            <div class="input-header-group">
                <span class="input-header">Close Month End</span>
                <wj-input-date
                    [(ngModel)]="endDate"
                    class="header-input"
                    name="endDate"
                    (ngModelChange)="groupRows()"
                    [selectionMode]="'Month'"
                    [format]="'MMM yyyy'"
                    [min]="minDate"
                    [max]="maxDate"
                ></wj-input-date>
            </div>

            <div class="input-header-group">
                <span class="input-header">Job Status</span>
                <wj-multi-select
                    name="jobActvityType"
                    (checkedItemsChanged)="refresh()"
                    [itemsSource]="activeMap"
                    [displayMemberPath]="'display'"
                    [checkedMemberPath]="'$checked'"
                ></wj-multi-select>
            </div>

            <div class="input-header-group">
                <span class="input-header">Group By</span>
                <wj-combo-box
                    [(ngModel)]="selectedGrouping"
                    name="selectedGrouping"
                    (ngModelChange)="groupRows()"
                    [itemsSource]="groupingOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>

            <div class="input-header-group">
                <span class="input-header">Cost Type</span>
                <wj-combo-box
                    [(ngModel)]="selectedCostType"
                    name="selectedGrouping"
                    (ngModelChange)="refresh()"
                    [itemsSource]="costTypesMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>

            <div class="input-header-group" [hidden]="selectedCostType !== 10">
                <span class="input-header">Labor Type</span>
                <wj-combo-box
                    [(ngModel)]="isCost"
                    name="isCost"
                    (ngModelChange)="refresh()"
                    [itemsSource]="boolMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid
            id="mainGrid"
            #mainGrid
            appAutoSize
            [padding]="73"
            (initialized)="grid.initialize(mainGrid)"
            [itemFormatter]="gridItemFormatter"
            (destroy)="grid.destroy()"
            [itemsSource]="grid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Job / Grouping'" [binding]="'job'" [width]="400"></wj-flex-grid-column>
            <wj-flex-grid-column
                [header]="'Close Month'"
                [binding]="'closeMonth'"
                [width]="150"
                [format]="'MMM yyyy'"
            ></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Estimate'" [binding]="'estimate'" [width]="160" [format]="gridFormat"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Actual'" [binding]="'actual'" [width]="150" [format]="gridFormat"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Variance'" [binding]="'delta'" [width]="170" [format]="gridFormat"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Percent'" [binding]="'percent'" [width]="150" [format]="'P2'"></wj-flex-grid-column>
        </wj-flex-grid>
        <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
    </div>
</div>
